'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBoxInfoBoxStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        padding-left: ', ';\n      '], ['\n        padding-left: ', ';\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  dense: _propTypes2.default.bool,
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  dense: false
};

/** Prop Receivers */
var offset = function offset(_ref) {
  var themeFromProvider = _ref.theme,
      labelPosition = _ref.labelPosition,
      dense = _ref.dense,
      fullWidth = _ref.fullWidth,
      bordered = _ref.bordered;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelPositionSide = theme.reactackle.components.selectBox.label.positionSide,
      styleKey = bordered ? 'bordered' : 'underlined',
      labelPositionSideSize = labelPositionSide.size[styleKey];

  var labelSizeSource = labelPositionSideSize;

  if (dense && !fullWidth) labelSizeSource = labelPositionSideSize.dense;else if (dense && fullWidth) labelSizeSource = labelPositionSideSize.denseFullWidth;else if (!dense && fullWidth) labelSizeSource = labelPositionSideSize.fullWidth;

  var labelSelectSpacing = (0, _reactackleCore.getValueString)(labelSizeSource.labelSelectSpacing);

  var breakpoints = labelPositionSide.breakpoints.map(function (item) {
    var offset = 'calc(' + (0, _reactackleCore.getValueString)(item.width) + ' + ' + labelSelectSpacing + ')';

    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, offset));
  });

  var defaultOffset = 'calc(' + (0, _reactackleCore.getValueString)(labelPositionSide.width) + ' + ' + labelSelectSpacing + ')';

  return labelPosition === 'side' && (0, _styledComponents.css)(['padding-left:', 'px;', ';'], defaultOffset, breakpoints);
};

/** STYLES */
var SelectBoxInfoBoxStyled = exports.SelectBoxInfoBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SelectBoxInfoBoxStyled'
})(['display:flex;', ';'], offset);

SelectBoxInfoBoxStyled.propTypes = propTypes;
SelectBoxInfoBoxStyled.defaultProps = defaultProps;
SelectBoxInfoBoxStyled.displayName = 'SelectBoxInfoBoxStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/styles/SelectBoxInfoBoxStyled.js
// module id = 226
// module chunks = 0